export default __webpack_public_path__ + "static/media/cyfhotelproject.5f20db65.jpg";